const LoadingOverlay = ({ isLoading, message }) => {
  return (
    isLoading && (
      <div className="loading-overlay">
        <div className="loading-spinner"></div>
        <p>{message}</p>
      </div>
    )
  );
};
export default LoadingOverlay;
